import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useGetOrCreateBriefForOrderItemMutation } from './Order.generated';
import { Loading } from '@99designs/spa-common';
import { linkTo } from '@99designs/routing';
import redirectTo from '@99designs/apps/spa/common/Ssr/redirectTo';

type BriefOrderParams = {
    orderItemId: string;
};

function BriefOrderItem() {
    const { orderItemId } = useParams<BriefOrderParams>() as BriefOrderParams;

    const [getOrCreateBriefForOrderItemMutation, { data, loading, error }] =
        useGetOrCreateBriefForOrderItemMutation();

    useEffect(() => {
        if (!data && !loading && !error) {
            getOrCreateBriefForOrderItemMutation({
                variables: { id: orderItemId },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (error) {
        throw error;
    }

    if (loading || !data) return <Loading />;

    redirectTo(linkTo.brief(data.orderItem.externalBriefId));

    return null;
}

export default BriefOrderItem;
